import { TranslatedStringTableFetcher } from '@fluidx/localize-js';
import { MenuViewStrings } from '@fluidx/office-fluid-types';
import { getDiscoverStrings } from './stringTypes';

const stringTableFetcher: TranslatedStringTableFetcher = (locale: string) =>
  import(/* webpackChunkName: "fluidContainerStrings" */ `./translations/${locale}/DiscoverStrings.json`);

export async function getStringTable(locale: string): Promise<MenuViewStrings> {
  const discoverStrings = await getDiscoverStrings(stringTableFetcher, locale);
  return {
    ...discoverStrings,
    ariaLabel: discoverStrings.discoverMenuAriaLabel,
    listAriaLabel: discoverStrings.discoverMenuListLabel
  };
}
